import { Component } from '@angular/core';

@Component({
  selector: 'app-dialog-spiegazione-gestione-documentale',
  standalone: false,

  templateUrl: './dialog-spiegazione-gestione-documentale.component.html',
  styleUrl: './dialog-spiegazione-gestione-documentale.component.scss',
})
export class DialogSpiegazioneGestioneDocumentaleComponent {
  documentiGenerali = [
    'Visura camerale',
    'Company Profile',
    'Procedura di Whistleblowing',
    'Modello di Organizzazione, Gestione e Controllo ex D.Lgs 231/2001',
    'Codice Etico',
    'Codice condotta fornitori',
    'Politiche HR',
    'Politica e cultura d’impresa e condotta',
    'Politica Sostenibilità',
    'Piano di transizione ai cambiamenti climatici',
    'Politiche relative all’uso delle risorse ed economia circolare',
    'Politiche connesse alle acque e risorse marine',
  ];

  iso14001 = [
    { code: '4.1', desc: 'Comprendere l’organizzazione e il suo contesto' },
    { code: '4.2', desc: 'Comprendere le esigenze e le aspettative delle parti interessate' },
    { code: '5.2', desc: 'Politica ambientale' },
    { code: '6.1', desc: 'Azioni per affrontare rischi e opportunità' },
    { code: '6.1.2', desc: 'Aspetti ambientali' },
    { code: '6.2', desc: 'Obiettivi ambientale e pianificazione per il loro raggiungimento' },
    { code: '7.1', desc: 'Risorse' },
  ];

  iso45001 = [
    { code: '4.1', desc: 'Comprendere l’organizzazione ed il suo contesto' },
    {
      code: '4.2',
      desc: 'Comprendere le esigenze e le aspettative dei lavoratori e di altre parti interessate',
    },
    { code: '5.2', desc: 'Politica per la SSL' },
    { code: '5.4', desc: 'Consultazione e partecipazione dei lavoratori' },
    { code: '6.1', desc: 'Azioni per affrontare rischi ed opportunità' },
    {
      code: '6.1.2',
      desc: 'Identificazione dei pericoli e valutazione dei rischi e delle opportunità',
    },
    { code: '6.2.1', desc: 'Obiettivi per la SSL' },
    { code: '8.1.2', desc: 'Eliminazione dei pericoli e riduzione dei rischi per la SSL' },
  ];

  closeDialog() {
    // Logica per chiudere il dialog (es. MatDialogRef.close())
  }
}
